module.exports = __webpack_public_path__ + "img/marisa kirisame_sc2.a63716c0.png";